import React from "react";
import VideoBlogLayout from "../../components/VideoBlogLayout";

const BlogAshaAIIntro = () => (
  <VideoBlogLayout
    category="Video Demo"
    eyebrow="Welcome to Asha"
    title="What is Asha AI, and why is it different?"
    subtitle="A guided walkthrough of the world's first and only AI operating system for dental — 10+ softwares and 20+ AI products in one unified platform that runs your practice on autopilot."
    author="Asha Team"
    date="May 23, 2026"
    readTime="6 min watch"
    videoUrl="https://www.loom.com/embed/2f1798865b044075b51a096937c470c5"
    videoTitle="Asha — AI Native Operating System for Dental"
    videoProvider="loom"
  >
    <div className="space-y-14">
      <div>
        <div className="inline-block px-3 py-1 text-xs font-semibold uppercase tracking-wider text-blue-700 bg-blue-50 rounded-full mb-4">
          Welcome
        </div>
        <p className="text-lg text-gray-600 leading-relaxed mb-4">
          Thanks for filling out our interest form. As part of our newsletter,
          we'll be sending you educational articles and videos about how dentists
          are leveraging Asha's AI to transform how they operate.
        </p>
        <p className="text-lg text-gray-600 leading-relaxed">
          To answer the question: Asha AI is the world's first and only{" "}
          <strong className="text-gray-900 font-semibold">
            AI operating system for dental
          </strong>
          .
        </p>
      </div>

      <div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 tracking-tight">
          Why do we call it an "AI operating system"?
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed">
          Because as opposed to a small point solution (like an AI receptionist)
          that you have to stitch together with all your different tools, Asha
          combines 10+ softwares and 20+ AI products into one unified platform
          to help you run your practice on autopilot.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-600 to-violet-500 flex items-center justify-center text-white font-bold text-lg shadow-md mb-4">
            10+
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Softwares</h3>
          <p className="text-base text-gray-600 leading-relaxed">
            PMS, Communication Suite, Marketing Suite, Payments Suite, Insurance
            Verification Suite, Billing Suite, Revenue Intelligence Suite, &
            more.
          </p>
        </div>
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-violet-500 to-blue-600 flex items-center justify-center text-white font-bold text-lg shadow-md mb-4">
            20+
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">AI Products</h3>
          <p className="text-base text-gray-600 leading-relaxed">
            AI EOB Posting, AI Claim Generation, AI Receptionist, AI Scribe, AI
            Outbound Calls, AI Insurance Verification, AI Case Acceptance, and
            so much more.
          </p>
        </div>
      </div>

      <div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 tracking-tight">
          How should we think about software vs AI?
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed mb-4">
          Asha's 10 softwares are meant to replace your existing softwares with
          one unified suite. Asha's 20 AI products, on the other hand, perform
          the work that your staff does today.
        </p>
        <p className="text-lg text-gray-600 leading-relaxed">
          Put simply: software does the work of your existing software, AI does
          the work of your staff.
        </p>
      </div>
    </div>
  </VideoBlogLayout>
);

export default BlogAshaAIIntro;
